import { render, staticRenderFns } from "./GovernanceReports.vue?vue&type=template&id=4ca6f612&"
import script from "./GovernanceReports.vue?vue&type=script&lang=js&"
export * from "./GovernanceReports.vue?vue&type=script&lang=js&"
import style0 from "./GovernanceReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports